export const NAME = 'KEY_ACCESS';